import { Component, Element, Host, Prop, h } from '@stencil/core';

import { validateVehicleConfigForm } from '../../../actions/actions.validation.vehicleConfig';
import { checkIneligibleTed } from '../../../actions/actions.vehicle-config';
import { DealerInfo } from '../../../interfaces/interface.dealer';
import { AnswerVehicle } from '../../../interfaces/interface.vehicle';
import EventBus from '../../../services/service.eventBus';
import { on as onAnswerChange } from '../../../store/store.answers';
import { VehicleConfigState, initialState as initialVehicleConfigState } from '../../../store/store.vehicle-config';

@Component({
  tag: 'ico-vehicle-config',
  styleUrl: 'ico-vehicle-config.css',
  shadow: true,
})
export class IcoVehicleConfig {
  @Element() el: HTMLElement;

  @Prop() vehicleConfig: VehicleConfigState = initialVehicleConfigState;
  @Prop() dealerInfo: DealerInfo;
  @Prop() vehicle: AnswerVehicle;
  @Prop() vehicleTrimId: number;
  @Prop() isDigitalRetailing: boolean;
  @Prop() theme: string;
  @Prop() allowIneligibleVehicleSubmission: boolean = false;

  componentWillLoad() {
    validateVehicleConfigForm(this.vehicle, this.vehicleConfig, true);

    onAnswerChange('set', (prop) => {
      // Validate vehicle on answerState
      if (prop === 'vehicle') {
        validateVehicleConfigForm(this.vehicle, this.vehicleConfig, false);
      }
    });
  }

  componentDidRender() {
    checkIneligibleTed(this.allowIneligibleVehicleSubmission);
    if (this.vehicleConfig.ineligibleTed) {
      const modal = this.el.shadowRoot.querySelector('ineligible-vehicle-modal');
      modal.ineligibleReason = this.vehicleConfig.ineligibleTed;
      modal.open();
    }
  }

  componentDidLoad() {
    EventBus.publish('ComponentHasLoaded', 'ico-vehicle-config');
  }

  render() {
    const hasTedSelections = !this.vehicleConfig.featuredEngine || !this.vehicleConfig.featuredDrivetrain || !this.vehicleConfig.featuredTransmission;
    const hasOptionSelections = this.vehicleConfig.featuredOptions.length === 0;
    const hasColorSelection = !this.vehicleConfig.featuredColor;

    return (
      <Host>
        <div class={`${this.theme}-theme`}>
          <div class="text-ico-body font-ico-body">
            <ico-config-header vehicleConfig={this.vehicleConfig} />

            {hasTedSelections && <vehicle-ted vehicleConfig={this.vehicleConfig} vehicleAnswers={this.vehicle} />}

            {hasOptionSelections && <vehicle-equipment vehicleConfig={this.vehicleConfig} vehicleAnswers={this.vehicle} vehicleTrimId={this.vehicleTrimId} />}

            {hasColorSelection && <vehicle-color vehicleConfig={this.vehicleConfig} vehicleColorIdAnswer={this.vehicle.colorId} />}

            <ineligible-vehicle-modal
              dealershipName={this.dealerInfo?.dealershipName}
              dealerId={this.dealerInfo?.dealerId}
              isDigitalRetailing={this.isDigitalRetailing}
              vehicle={this.vehicle}
            />
          </div>
        </div>
      </Host>
    );
  }
}
